export const colors = {
	'color-red': {
		color: '#f44336',
	},
	'color-pink': {
		color: '#e91e63',
	},
	'color-purple': {
		color: '#9c27b0',
	},
	'color-deeppurple': {
		color: '#673ab7',
	},
	'color-indigo': {
		color: '#3f51b5',
	},
	'color-blue': {
		color: '#2196f3',
	},
	'color-lightblue': {
		color: '#03a9f4',
	},
	'color-cyan': {
		color: '#00bcd4',
	},
	'color-teal': {
		color: '#009688',
	},
	'color-green': {
		color: '#4caf50',
	},
	'color-lightgreen': {
		color: '#8bc34a',
	},
	'color-lime': {
		color: '#cddc39',
	},
	'color-yellow': {
		color: '#ffeb3b',
	},
	'color-amber': {
		color: '#ffc107',
	},
	'color-orange': {
		color: '#ff9800',
	},
	'color-deeporange': {
		color: '#ff5722',
	},
	'color-brown': {
		color: '#795548',
	},
	'color-grey': {
		color: '#9e9e9e',
	},
	// 'color-bluegrey': {
	// 	color: '#607d8b',
	// }
}

export const palette = Object.values(colors).map(item => item.color)
